export var LANGUAGES = {
    AM: 'am',
    AR: 'ar',
    ZH: 'zh-cn',
    DE: 'de',
    GN: 'gn',
    GU: 'gu',
    HE: 'he',
    HI: 'hi',
    HMN: 'hmn',
    JA: 'ja',
    KO: 'ko',
    MS: 'ms',
    MK: 'mk',
    MN: 'mn',
    FA: 'fa',
    PL: 'pl',
    PT_BR: 'pt-br',
    PA: 'pa',
    PS: 'ps',
    RU: 'ru',
    SR: 'sr',
    SO: 'so',
    ES: 'es',
    SW: 'sw',
    TR: 'tr',
    UK: 'uk',
    EN: 'en',
    FIL: 'fil',
    FR: 'fr',
    VI: 'vi'
};
export var LANGUAGES_FULL_TEXT = {
    AM: 'Amharic',
    AR: 'Arabic',
    ZH: 'Chinese (Simplified)',
    DE: 'German',
    GN: 'Guarani',
    GU: 'Gujarati',
    HE: 'Hebrew',
    HI: 'Hindi',
    HMN: 'Hmong',
    JA: 'Japanese',
    KO: 'Korean',
    MS: 'Malay',
    MK: 'Macedonian',
    MN: 'Mongolian',
    FA: 'Persian',
    PL: 'Polish',
    PT_BR: 'Portuguese (Brazil)',
    PA: 'Punjabi',
    PS: 'Pashto',
    RU: 'Russian',
    SR: 'Serbian',
    SO: 'Somali',
    ES: 'Spanish',
    SW: 'Swahili',
    TR: 'Turkish',
    UK: 'Ukrainian',
    EN: 'English',
    FIL: 'Filipino',
    FR: 'French',
    VI: 'Vietnamese'
};
export var RTL_LANGUAGES = [
    LANGUAGES.AR,
    LANGUAGES.HE,
    LANGUAGES.FA,
    LANGUAGES.PS,
];
export var isLanguageRTL = function (languageCode) { return RTL_LANGUAGES.includes(languageCode); };
export var getLanguageFullName = function (code) {
    // @ts-ignore
    return LANGUAGES_FULL_TEXT[code];
};
export var ALWAYS_ON_CRAWLER = "AlwaysOn-Crawler";
